export default "__VITE_ASSET__D6l5CB36__"